import { Table, Typography, Tag, Space } from "antd";
import { ColumnsType } from "antd/es/table";
import { Clock, User as UserIcon } from "lucide-react";
import moment from "moment";

interface PropsTable {
  id: number;
  createdAt: Date;
  order_id: number;
  name: string;
  orders_status_id: number;
}

interface Props {
  userName: string;
  data: PropsTable[];
}

const { Text } = Typography;

// Función para obtener el color del estado
const getStatusColor = (statusName: string) => {
  const statusLower = statusName.toLowerCase();
  if (statusLower.includes("pendiente") || statusLower.includes("pago")) {
    return "orange";
  }
  if (statusLower.includes("proceso") || statusLower.includes("preparación")) {
    return "blue";
  }
  if (statusLower.includes("enviado") || statusLower.includes("envío")) {
    return "cyan";
  }
  if (statusLower.includes("entregado") || statusLower.includes("completado")) {
    return "green";
  }
  if (statusLower.includes("cancelado") || statusLower.includes("rechazado")) {
    return "red";
  }
  return "default";
};

export const TableOrderById = ({ data, userName }: Props) => {
  const columns: ColumnsType<PropsTable> = [
    {
      title: "Estado",
      dataIndex: "name",
      render: (name: string) => (
        <Tag
          color={getStatusColor(name)}
          style={{
            borderRadius: 12,
            padding: "4px 12px",
            fontSize: 13,
            fontWeight: 500,
            border: "none",
          }}
        >
          {name}
        </Tag>
      ),
    },
    {
      title: "Usuario",
      render: () => (
        <Space size={8}>
          <UserIcon size={16} style={{ color: "#8c8c8c" }} />
          <Text strong style={{ fontSize: 13 }}>
            {userName}
          </Text>
        </Space>
      ),
    },
    {
      title: "Fecha",
      dataIndex: "createdAt",
      render: (_, item) => (
        <Space size={8}>
          <Clock size={16} style={{ color: "#8c8c8c" }} />
          <div>
            <Text style={{ fontSize: 13, display: "block" }}>
              {moment(item.createdAt).format("DD/MM/YYYY")}
            </Text>
            <Text type="secondary" style={{ fontSize: 12 }}>
              {moment(item.createdAt).format("HH:mm:ss")}
            </Text>
          </div>
        </Space>
      ),
    },
  ];

  return (
    <Table
      style={{ width: "100%" }}
      pagination={false}
      columns={columns}
      dataSource={data}
      rowKey="id"
      size="middle"
      className="modern-table"
    />
  );
};
